"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var LvFalconNavigatorWithArrowBackButtons_1 = require("./LvFalconNavigatorWithArrowBackButtons");
var journey_services_1 = require("@ferry/journey-services");
/**
 * This navigator was created as a temporary fix to getting SESSION EXPIRED page on iOS/Safari
 * when getting back to Your Cars page from a journey with navigateToUrl command.
 *
 * USE ONLY WHEN ABSOLUTELY NECESSARY!!!
 *
 * Technical debt ticket to find a permanent fix: FAL-12961
 */
var LvFalconNavigatorWithArrowBackAnchors = /** @class */ (function (_super) {
    __extends(LvFalconNavigatorWithArrowBackAnchors, _super);
    function LvFalconNavigatorWithArrowBackAnchors() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LvFalconNavigatorWithArrowBackAnchors.prototype.renderBackButtonTop = function () {
        // @ts-ignore Does not exist in typedefs, but defined in journey defs
        var hrefLink = journey_services_1.productHelper.isWolfMotor(this.props.interaction) ? this.props.page["navigatorBackAnchorHref"] + "/" + this.props.interaction.agreementNumber : this.props.page["navigatorBackAnchorHref"];
        return ((0, jsx_runtime_1.jsx)("a", { id: "navigatorBackAnchorTop", className: "btn btn-back-journey-arrow-white", href: hrefLink, children: "Back" }));
    };
    LvFalconNavigatorWithArrowBackAnchors.prototype.renderBackButtonBottom = function () {
        // @ts-ignore Does not exist in typedefs, but defined in journey defs
        var hrefLink = journey_services_1.productHelper.isWolfMotor(this.props.interaction) ? this.props.page["navigatorBackAnchorHref"] + "/" + this.props.interaction.agreementNumber : this.props.page["navigatorBackAnchorHref"];
        return ((0, jsx_runtime_1.jsx)("a", { id: "navigatorBackAnchorBottom", className: "btn btn-back-journey-arrow-blue", href: hrefLink, children: "Back" }));
    };
    return LvFalconNavigatorWithArrowBackAnchors;
}(LvFalconNavigatorWithArrowBackButtons_1.default));
exports.default = LvFalconNavigatorWithArrowBackAnchors;
//# sourceMappingURL=LvFalconNavigatorWithArrowBackAnchors.js.map